import React from "react"
import { Button } from "../Button"

/**
 * Become Associate / Become Affiliate CTAs from buildReapplyPathOffer action state.
 * Consumers supply click handlers (e.g. confirmation modal vs immediate redirect).
 */
const ReapplyPathOfferApplyActions = ({
  associateAction,
  affiliateAction,
  onBecomeAssociate,
  onBecomeAffiliate,
  className = "m-2",
}) => {
  const showAssociate = Boolean(associateAction?.showApplyCta)
  const showAffiliate = Boolean(affiliateAction?.showApplyCta)

  if (!showAssociate && !showAffiliate) {
    return null
  }

  return (
    <>
      {showAssociate ? (
        <Button
          color="primary"
          className={className}
          onClick={onBecomeAssociate}
        >
          Become Associate
        </Button>
      ) : null}
      {showAffiliate ? (
        <Button
          color="primary"
          className={className}
          onClick={onBecomeAffiliate}
        >
          Become Affiliate
        </Button>
      ) : null}
    </>
  )
}

export default ReapplyPathOfferApplyActions
